<template>
  <form>
    <div id="div-appointment-info" class="vs-con-loading__container">
      <vs-row>
        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <vs-input
            disabled
            label-placeholder="Nome do paciente"
            v-model="this.data.appointment.patient.name"
            class="mt-5 w-full"
          />
        </vs-col>

        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
          <!-- ForwardedBy -->
          <vs-input name="forwardedBy" disabled v-model="this.data.appointment.patient.forwardedBy" label-placeholder="Encaminhado" class="mt-5 w-full" />
        </vs-col>      
      </vs-row>

      <vs-row>
        <vs-col vs-type="flex" vs-align="center" vs-lg="2" vs-md="12" vs-sm="12" vs-xs="12">
          <div>
          <p class="label">Idade:</p>
          <vs-input-number disabled v-model="this.data.appointment.patientAge.years" label="Anos:" />
          </div>
        </vs-col>
        
        <vs-col vs-type="flex" vs-align="center" vs-lg="2" vs-md="12" vs-sm="12" vs-xs="12">
          <vs-input-number
            disabled
            v-model="this.data.appointment.patientAge.months"
            label="Meses:"
          />
        </vs-col>

        <vs-col vs-type="flex" vs-align="center" vs-lg="2" vs-md="12" vs-sm="12" vs-xs="12">
          <vs-input-number disabled v-model="this.data.appointment.patientAge.days" label="Dias:" />
        </vs-col>
      </vs-row>

      <br />

      <br />
    </div>
  </form>
</template>

<script>
// Services
import AppointmentService from "../../../services/AppointmentService";

export default {
  components: {},
  props: {
    idAppointment: {
      required: true
    }
  },
  data() {
    return {
      data: {
        idAppointment: 0,
        appointment: {
          patient: {
            name: ""
          },
          patientAge: {
            years: 0,
            months: 0,
            days: 0
          }
        }
      },
      notifications: {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      defaultDivId: "div-appointment-info"
    };
  },
  mounted: function() {
    this.data.idAppointment = this.$props.idAppointment;
    this.get();
  },
  methods: {
    async get() {
        this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: {
          idAppointment: this.data.idAppointment
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = false;

      var result = await AppointmentService.get(payload);

      if (result.status == 200) {
        if (result.data.result != null) {
          this.data.appointment = result.data.result;
        }
      }

        this.closeLoadingDiv(this.defaultDivId);
    },
    openLoadingInDiv(divId) {
      this.$vs.loading({
        container: "#" + divId,
        scale: 0.6
      });
    },
    closeLoadingDiv(divId) {
      this.$vs.loading.close("#" + divId + " > .con-vs-loading");
    }
  }
};
</script>

<style scoped>
.label {
  padding-left: 5px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}
</style>